"use client";
import { useState } from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user/current-user-provider";
import { useJuneSoComponentContext } from "@stadium/services/june-analytics";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";

import Button from "@stadium/shared/src/components/shared/button";
import MailTo from "@stadium/ui/src/components/mail-to";

import { BYSTADIUM_BOOK_A_CALL } from "@stadium/helpers/src/app-routes";
import { FEATURE_PACKAGES, FEATURE_PACKAGES_SERVICES, TALK_TO_SALES } from "constants/june-so";

import style from "./main.module.scss";

const DEFAULT_OBJ = {};

const PricingTableHeader = ({ hideCurrentPackage = false }) => {
  const { push } = useRouter();
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const bookACallCtaText = useConfig(getBookACallCtaText);

  const { componentName } = useJuneSoComponentContext();
  const { childCompany } = useCurrentUserContext();
  const { displayOnFe: isActivePackage, name: currentPackageName } =
    childCompany?.activePackage || DEFAULT_OBJ;
  const handleTalkToSalesClick = () => {
    setIsBtnLoading(true);
    const bookACallForm = document.getElementById("book-a-call");
    if (bookACallForm) {
      bookACallForm.scrollIntoView?.({ behavior: "smooth", block: "nearest" });
      return setIsBtnLoading(false);
    }
    push(BYSTADIUM_BOOK_A_CALL);
  };

  const juneSoDefaultProps = {
    componentName,
    elementPosition: FEATURE_PACKAGES,
    services: FEATURE_PACKAGES_SERVICES,
  };

  return (
    !isActivePackage &&
    currentPackageName && (
      <div className={style.packagesHeaderDescription}>
        {hideCurrentPackage
          ? "Your trial includes premium features. To maintain premium access, reach out to"
          : `You’re currently on the ${currentPackageName} Package, which is a legacy offering. We've upgraded our Packages with premium features to deliver even more value. Have questions
        about upgrading?`}
        {hideCurrentPackage ? (
          <>
            &nbsp;
            <MailTo
              recipient="success@bystadium.com"
              className={`${style.packagesHeaderDescriptionLink} ${style.packagesHeaderDescriptionLinkMailTo}`}
            />
            &nbsp;to lock in your custom pricing.
          </>
        ) : (
          <Button
            juneSoProps={{
              ...juneSoDefaultProps,
              target: `${currentPackageName}-${TALK_TO_SALES}`,
            }}
            styleType="link"
            className={style.packagesHeaderDescriptionLink}
            onClick={() => handleTalkToSalesClick()}
            disabled={isBtnLoading}
            isLoading={isBtnLoading}
            title={bookACallCtaText}
          >
            {bookACallCtaText}
          </Button>
        )}
      </div>
    )
  );
};

export default PricingTableHeader;
